import React from 'react';
import { motion } from 'framer-motion';
import { Moon } from 'lucide-react';
export function PainSection() {
  return <section className="py-14 md:py-20 bg-off-white" data-id="element-232">
      <div className="container mx-auto px-4" data-id="element-233">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="max-w-3xl mx-auto text-center" data-id="element-234">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-navy/5 mb-8" data-id="element-235">
            <Moon size={32} className="text-navy" data-id="element-236" />
          </div>

          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-10 text-navy" data-id="element-237">
            ESTO ES LO QUE QUITA EL SUEÑO A LAS BUENAS PERSONAS
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-gray-700 leading-relaxed text-left" data-id="element-238">
            <p data-id="element-239">
              No eres descuidado. No eres irresponsable. Eres una persona que
              trabaja duro, ama a su familia y quiere hacer lo correcto.
            </p>

            <p data-id="element-240">
              Pero los seguros son confusos. El lenguaje es complicado. Las
              opciones son abrumadoras. Y en algún momento simplemente confiaste
              en que alguien más lo había manejado correctamente.
            </p>

            <div className="bg-white p-8 rounded-xl shadow-md my-10 border border-gray-100 relative overflow-hidden" data-id="element-241">
              <div className="absolute top-0 left-0 w-2 h-full bg-gold" data-id="element-242"></div>
              <p className="font-serif text-2xl text-navy italic" data-id="element-243">
                Y esa incertidumbre silenciosa — ese "creo que estoy cubierto...
                espero estar cubierto..." — ese es el sentimiento que nunca
                desaparece del todo.
              </p>
            </div>

            <p className="text-3xl font-bold text-center text-navy pt-8" data-id="element-244">
              Hasta ahora.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}